import React from 'react';
import { toAbsoluteUrl } from '../../../../../../_start/helpers';
import { SpecializationHeader } from './SpecializationHeader';

interface Props {
  data: SpecializationHeader;
  update: (fieldsToUpdate: Partial<SpecializationHeader>) => void;
}

export const SpecializatiosHeaderFigure: React.FC<Props> = ({
  data,
  update,
}) => {
  return (
    <div className="specializations-header__figure">
      {data.image ? (
        <div className="overlay">
          <div className="overlay-wrapper">
            <img alt="Uploaded" src={data.image} />
          </div>
          <div className="overlay-layer bg-dark bg-opacity-10 flex-column">
            <div>
              <button
                name="image"
                className="btn btn-primary btn-shadow"
                onClick={() =>
                  update({
                    image: '',
                    image_alt: '',
                  })
                }
              >
                Remove
              </button>
              <label
                className="btn btn-light-primary btn-shadow ms-2"
                data-bs-toggle="modal"
                data-bs-target={`#${data.name}-${data.id}`}
              >
                Change
              </label>
            </div>

            <input
              placeholder="Alt attribute"
              className="w-50 mt-2 form-control form-control-lg form-control-solid"
              type="text"
              value={data.image_alt ?? ''}
              onChange={(event) => update({ image_alt: event.target.value })}
            />
          </div>
        </div>
      ) : (
        <>
          <label
            data-bs-toggle="modal"
            data-bs-target={`#${data.name}-${data.id}`}
          >
            <img
              src={toAbsoluteUrl('/assets/images/900x630.png')}
              alt="Placeholder"
            />
          </label>
        </>
      )}
    </div>
  );
};
